<script setup lang="ts">
import type { CmsCustomComponentType } from '~/layers/cms/app/types/cmsTypes'

const props = defineProps<{
  cmsDataPath: (string | number)[]
}>()
const nazwa_komponentu = 'Galerie/VerticalGallery'
const component_default_values: CmsCustomComponentType = {
  id: { value: undefined, default_value: 'Lorem Ipsum', settingType: 'text', setting_label: 'zmien id' }
}
</script>

<template>
  <CmsCustomComponent
    v-slot="{ component_values }"
    :cms-data-path="[...props.cmsDataPath]"
    :component-name="nazwa_komponentu"
    :defaults="component_default_values"
    :open-options="true"
  >
    <div
      :id="component_values?.id?.value"
      class="flex flex-col gap-5 xl:gap-10 px-2xl items-start"
    >
      <div class="flex flex-col gap-5 xl:gap-7.5">
        <span class="text-H1 text-Tekst">
          <CmsText :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_1']" />
        </span>
        <span class="text-H4 text-Teksty">
          <CmsText :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_2']" />
        </span>
      </div>
      <CmsCustomComponentList
        v-slot="{ component_values: componentListValues }"
        :cms-data-path="[...props.cmsDataPath, 'component_data', 'list_1']"
        :open-options="true"
        component-name="images_list"
        class="min-w-5 min-h-5 w-full"
      >
        <VerticalGaleryComponent
          :cms-data-path="[...props.cmsDataPath, 'component_data', 'list_1', 'component_data']"
          :data-length="componentListValues.length"
          :data="componentListValues"
        />
      </CmsCustomComponentList>
    </div>
  </CmsCustomComponent>
</template>
